import { z } from 'zod';
import { localizedTextSchema } from './localized';

export const insuranceSchema = z.object({
  id: z.string().uuid().optional(),
  projectId: z.string().uuid(),
  internalName: z.string().min(1, 'Interne naam is verplicht'),
  description: localizedTextSchema,
  code: z.coerce.number().int('Code moet een geheel getal zijn').nonnegative('Code moet positief zijn'),
  articleNumber: z.string().min(1, 'Artikelnummer is verplicht'),
  price: z.coerce.number().nonnegative('Prijs moet positief zijn'),
  isActive: z.boolean().default(true),
});

export const createInsuranceSchema = insuranceSchema.omit({ id: true });
export const updateInsuranceSchema = insuranceSchema.partial().omit({ id: true });

export type InsuranceFormData = z.infer<typeof createInsuranceSchema>;
export type InsuranceSchema = z.infer<typeof insuranceSchema>;
